<template>
  <v-card :flat="flat" :color="transparent ? 'transparent' : ''" :dark="dark">
    <h5 v-text="$t('text.your company')" />
    
    <br>
    {{ $t('text.org_no') }}: {{ customer.OrganisationNumber }} 
    <br>
    {{$t('text.name')}}: {{ customer.Name}} 
    <br>


    <template v-if="parentCustomer">
      <br>
      {{ $t('text.main_office') }}: {{ parentCustomer.Name }}
      <br>
    </template>

    <template v-if="customerGoup">
      <br>
      {{ $t('text.part_of_group') }}:
      <v-list-item class="px-0" style="max-width: 300px;">
        <div class="v-list-item-icon my-auto mr-3">
          <CustomerGroupImage :size="40" :relativePath="customerGoup && customerGoup.Image">
          </CustomerGroupImage>
        </div>
        <div class="v-list-item-content py-0">
          <v-list-item-title>
            {{ customerGoup.Name }}
          </v-list-item-title>
        </div>
      </v-list-item>
    </template>

  </v-card>
</template>


<script>
import CustomerGroupImage from "@/components/Cards/CustomerGroupImage.vue";
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";

export default {
  name: "CompanyContactCard",
  mixins: [AuthStoreMixin],
  props: {
    dark: Boolean,
    transparent: Boolean,
    flat: Boolean,
  },
  components: {
    CustomerGroupImage,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {
    userInfo() {
      if (this.authUserInfo) return this.authUserInfo;
      return { Customer: {}, Provider: {} };
    },

    customer() {
      return this.userInfo && this.userInfo.Customer;
    },

    customerGoup() {
      return this.customer && this.customer.CustomerGroup;
    },

    parentCustomer() {
      return this.customer && this.customer.Parent;
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>